// searchRostersConstants.js
// Shared, render-stable constants/helpers for SearchRosters and RosterDetailCard.
// Hoisted to module scope so they are created once (not on every render).

import { styled } from "@mui/material/styles";
import { keyframes } from "@mui/system";
import { Chip, Typography } from "@mui/material";

export const bounceAnimation = keyframes`
  0%, 100% {
    transform: translateY(0); /* Start and end at the same position */
  }
  50% {
    transform: translateY(-5px); /* Move up slightly */
  }
`;

export const SubHeading = styled(Typography)(({ theme }) => ({
  fontFamily: "Urbanist, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  fontWeight: "bold",
  paddingBottom: theme.spacing(0.75),
}));

export const StyledChip = styled(Chip)(() => ({
  borderRadius: "4px",
  whiteSpace: "normal",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const LimitChip = styled(Chip)(() => ({
  fontWeight: "bold",
  color: "#3299FF",
}));

export const AutocompleteWrapper = styled("div")({
  maxHeight: "100px",
  overflowY: "auto",
});

export const statusColorMap = {
  Active: "#3299FF",
  "Pending Cancellation": "#FF9800", // Orange
  Cancelled: "#F44336", // Red
  Closed: "#9E9E9E", // Grey
};

export const sortOptions = [
  { value: "1", label: "Roster Id: Low to High" },
  { value: "2", label: "Roster Id: High to Low" },
  { value: "3", label: "Wave: Low to High" },
  { value: "4", label: "Wave: High to Low" },
  { value: "5", label: "Production Date: Newest First" },
  { value: "6", label: "Production Date: Oldest First" },
];

export const getRequestStatusIcon = (status) => {
  switch (status) {
    case "In Progress":
      return "/assets/icons/Logout.png";
    case "On Hold":
      return "/assets/icons/Hourglass.png";
    case "Cancelled":
      return "/assets/icons/Close.png";
    case "Closed":
      return "/assets/icons/Checked.png";
    case "Extended Training/Nesting - Full":
      return "/assets/icons/Backup.png";
    case "Extended Training/Nesting - Partial":
      return "/assets/icons/History.png";
    default:
      return null;
  }
};

export const getRosterStatusIcon = (status) => {
  switch (status) {
    case "Active":
      return "/assets/icons/Logout.png";
    case "Cancelled":
      return "/assets/icons/Close.png";
    case "Closed":
      return "/assets/icons/Checked.png";
    default:
      return null;
  }
};

export const iconButtonStyle = {
  color: "#3299FF",
  position: "relative",
  "&:hover": {
    transform: "scale(1.1, 1.2)",
    backgroundColor: "rgba(50, 153, 255, 0.1)",
  },
  transition: "all 0.3s ease-in-out",
};

export const getConditionalIconStyle = (
  enabled = true,
  baseColor = "#3299FF",
  disabledColor = "red",
  hoverColorEnabled = "#2878CC",
  hoverColorDisabled = "darkred",
) => ({
  color: enabled ? baseColor : disabledColor,
  position: "relative",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.1, 1.2)",
    backgroundColor: "rgba(50, 153, 255, 0.1)",
    color: enabled ? hoverColorEnabled : hoverColorDisabled,
  },
});
